export default {
  LOCKER_URL: 'https://locker.io',
  LOCKER_LINK: 'https://support.locker.io/articles/Import-and-Export-data-5ddd61fc597544f38361f47841eebccb',
  BITWARDEN_LINK: 'https://support.locker.io/articles/Import-from-Bitwarden-7ef22c6d93f34e1581991adc8eedb027',
  LASTPASS_LINK: 'https://support.locker.io/articles/Import-from-LastPass-e5e86298c03d4eb180d19dec78e3db11',
  CHROME_LINK: 'https://support.locker.io/articles/Import-from-Google-Chrome-3418bcd6e1ea48b6a891d1f828e46ebb',
  FIREFOX_LINK: 'https://support.locker.io/articles/Import-from-Firefox-1995673b585a4a7f98192abdea06a0e6',
  ONE_PASSWORD_LINK: 'https://support.locker.io/articles/Import-from-1Password-50b668a9f5ab439a9c10f05df5de8544',
  DOWNLOAD_DESKTOP_URL: 'https://locker.io/passwords/download',
  DOC_LINKS: {
    vi: {
      SECURITY_UPGRADE_URL: 'https://locker.io/vi/blog/nang-cap-bao-mat-khoa-chinh-master-key',
      DESKTOP_CONNECT_GUIDE_URL: 'https://support.locker.io/vi/locker-general/login-unlock/unlock-methods#tr%C3%AAn-web-app'
    },
    en: {
      SECURITY_UPGRADE_URL: 'https://locker.io/en/blog/master-key-security-upgrade',
      DESKTOP_CONNECT_GUIDE_URL: 'https://support.locker.io/en/locker-general/login-unlock/unlock-methods#on-web-app'
    }
  }
}
